export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5150.3926b5ba.jpg";